<template>
  <v-content>
    <sc-flex :is-column="true" :gap="16">
      <sc-h1>Customized Words (Variables)</sc-h1>

      <v-card class="content-container">
        <v-card-text>
          <div style="text-align: left;">
            <sc-h4>Questionnaire Related</sc-h4>

            <ul
              v-for="item in Object.keys(
                customizedWordsVariables.questionnaireVariables,
              )"
              :key="item"
            >
              <li style="margin-bottom: 0;">
                <b>{{ item }}</b> -
                {{
                  customizedWordsVariables.questionnaireVariables[item]
                    .definition
                }}. Example:
                <b
                  >“{{
                    customizedWordsVariables.questionnaireVariables[item]
                      .example
                  }}”</b
                >
              </li>
            </ul>

            <br />
            <sc-h4>User Related</sc-h4>
            <ul
              v-for="item in Object.keys(
                customizedWordsVariables.userVariables,
              )"
              :key="item"
            >
              <li style="margin-bottom: 0;">
                <b>{{ item }}</b> -
                {{ customizedWordsVariables.userVariables[item].definition }}.
                Example:
                <b
                  >“{{
                    customizedWordsVariables.userVariables[item].example
                  }}”</b
                >
              </li>
            </ul>

            <br />
            <sc-h4>Entity Related</sc-h4>
            <ul
              v-for="item in Object.keys(
                customizedWordsVariables.entityVariables,
              )"
              :key="item"
            >
              <li style="margin-bottom: 0;">
                <b>{{ item }}</b> -
                {{ customizedWordsVariables.entityVariables[item].definition }}.
                Example:
                <b
                  >“{{
                    customizedWordsVariables.entityVariables[item].example
                  }}”</b
                >
              </li>
            </ul>
          </div>
        </v-card-text>
      </v-card>
    </sc-flex>
  </v-content>
</template>

<script>
import { customizedWordsVariables } from '@/constants/variables';

export default {
  name: 'VariableHelpers',
  data() {
    return {
      customizedWordsVariables,
    };
  },
  computed: {},
  created() {},
};
</script>

<style scoped></style>
